import React, { FunctionComponent } from "react";
import { Link, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from "react-i18next";
import { Cup, Race } from "/src/domain/challenges/ChallengeRatingCup";

interface RatingHeaderData {
    cup: Cup
}

const RatingHeader: FunctionComponent<RatingHeaderData> = ({ cup }) => {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
        <div className={classes.container}>
            <h2 className={classes.rating}>{cup.name}</h2>
            <div className={classes.raceContainer}>
                {cup.races.map((r: Race, index: number) => (
                    <Typography key={r.id} variant={"body1"} className={classes.race}>
                        <Link href={r.protocolLink} target="_blank" color={Boolean(r.protocolLink) ? "primary" : "textSecondary"}>{t('race')} {index + 1} - {r.name}</Link>
                    </Typography>
                ))}
            </div>
            {Boolean(cup.logoUrl) && <div className={classes.logoContainer}>
                <img src={cup.logoUrl} className={classes.logo} alt={`${cup.name} logo`} />
            </div>}
        </div>
    )
}

const useStyles = makeStyles((muiTheme) => ({
    container: {
        margin: "2rem 0"
    },
    rating: {
        color: muiTheme.palette.primary.contrastText,
        padding: '1rem 5rem 1rem 1.5rem',
        fontSize: '1.15rem',
        fontWeight: 500,
        background: `url(${require('../../assets/icons/primary_rect.svg')})`,
        backgroundRepeat: 'no-repeat',
        display: 'inline-block',
        backgroundPositionX: 'right',
        backgroundSize: 'cover'
    },
    raceContainer: {
        margin: "1rem"
    },
    race: {
        marginBottom: "0.5rem"
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    logo: {
        maxHeight: '8rem',
        maxWidth: "90%"
    }
}))

export default RatingHeader